import type { DateValue } from "reka-ui";
import {
  CalendarDate,
  CalendarDateTime,
  fromDate,
  getLocalTimeZone,
  toCalendarDate,
  toCalendarDateTime,
} from "@internationalized/date";

/**
 * Converts a timestamp, Date, or ISO string to a CalendarDate (date-only, no time).
 */
export function toCalendarDateValue(value: number | Date | string): CalendarDate {
  const date = value instanceof Date ? value : new Date(value);
  const zoned = fromDate(date, getLocalTimeZone());
  return toCalendarDate(zoned);
}

/**
 * Converts a timestamp, Date, or ISO string to a CalendarDateTime (date + time, no timezone).
 */
export function toCalendarDateTimeValue(value: number | Date | string): CalendarDateTime {
  const date = value instanceof Date ? value : new Date(value);
  const zoned = fromDate(date, getLocalTimeZone());
  return toCalendarDateTime(zoned);
}

/**
 * Converts a Reka UI DateValue back to a Unix timestamp (milliseconds).
 */
export function dateValueToTimestamp(value: DateValue): number {
  return value.toDate(getLocalTimeZone()).getTime();
}

/**
 * Converts a Reka UI DateValue back to a native JavaScript Date.
 */
export function dateValueToDate(value: DateValue): Date {
  return value.toDate(getLocalTimeZone());
}
